import { useCallback } from "react";
import html2canvas from "html2canvas";

export function useFlowchartExport(
  canvasRef: React.RefObject<HTMLElement | null>,
  title: string
) {
  const exportPNG = useCallback(async () => {
    const el = canvasRef.current;
    if (!el) return;

    try {
      const canvas = await html2canvas(el, {
        backgroundColor: "#ffffff",
        scale: 2,
        useCORS: true,
      });

      const link = document.createElement("a");
      link.download = `${title.replace(/[^a-zA-Z0-9]/g, "_")}_flowchart.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (err) {
      console.error("Flowchart export failed:", err);
    }
  }, [canvasRef, title]);

  return { exportPNG };
}
